import {DataFrameRenderOverrides} from './DataFrameTable';

/**
 * Merges multiple DataFrameRenderOverrides objects into a single override.
 *
 * For render function maps (columnNameToHeaderCellRenderFn, columnNameToDataCellRenderFn,
 * columnNameToHeaderDecorationRenderFn, columnNameToDataCellDecorationRenderFn),
 * later overrides win on conflict for the same column name.
 *
 * For hiddenColumnNames, all sets are unioned together.
 */
export default function mergeDataFrameRenderOverrides(
  ...overrides: Array<DataFrameRenderOverrides>
): DataFrameRenderOverrides {
  const merged: DataFrameRenderOverrides = {};

  for (const override of overrides) {
    if (override.columnNameToHeaderCellRenderFn != null) {
      merged.columnNameToHeaderCellRenderFn = {
        ...merged.columnNameToHeaderCellRenderFn,
        ...override.columnNameToHeaderCellRenderFn,
      };
    }

    if (override.columnNameToDataCellRenderFn != null) {
      merged.columnNameToDataCellRenderFn = {
        ...merged.columnNameToDataCellRenderFn,
        ...override.columnNameToDataCellRenderFn,
      };
    }

    if (override.columnNameToHeaderDecorationRenderFn != null) {
      merged.columnNameToHeaderDecorationRenderFn = {
        ...merged.columnNameToHeaderDecorationRenderFn,
        ...override.columnNameToHeaderDecorationRenderFn,
      };
    }

    if (override.columnNameToDataCellDecorationRenderFn != null) {
      merged.columnNameToDataCellDecorationRenderFn = {
        ...merged.columnNameToDataCellDecorationRenderFn,
        ...override.columnNameToDataCellDecorationRenderFn,
      };
    }

    if (override.hiddenColumnNames != null) {
      const existingHidden = merged.hiddenColumnNames ?? new Set<string>();
      merged.hiddenColumnNames = new Set([...existingHidden, ...override.hiddenColumnNames]);
    }
  }

  return merged;
}
